import { useState } from "react";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import DepositStocksTransferModal from "./DepositStocksTransferModal";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import EditProductModal from "./EditProductModal";
import { useAppDispatch } from "../../../../redux/hooks";
import {
  postDeleteDepositStockProduct,
  postEditDepositStockProduct,
} from "../../../../redux/api/inventory.api";
import usePermissions from "../../../../router/usePermissions";
import { inventoryRoutes } from "../../../../router/routesConstants";
import userRoles from "../../../../constants/userRoles";

interface DepositStocksActionButtonsProps {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}

function DepositStocksActionButtons({
  crudData,
  tableContext,
}: DepositStocksActionButtonsProps) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const [isSplitModalOpen, setIsSplitModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const tableFilterData = {
    page: tableContext.tablePagination.page,
    perPage: tableContext.tablePagination.rowsPerPage,
    alley: tableContext.tableSearch?.alley,
    building: tableContext.tableSearch?.building,
    cell: tableContext.tableSearch?.cell,
    column: tableContext.tableSearch?.column,
    island: tableContext.tableSearch?.island,
    productCode: tableContext.tableSearch?.productCode,
    productName: tableContext.tableSearch?.productName,
    row: tableContext.tableSearch?.row,
    shelf: tableContext.tableSearch?.shelf,
  };

  const handleDeleteProduct = () => {
    dispatch(
      postDeleteDepositStockProduct({
        idActivCel: crudData.idActivCel,
        filters: tableFilterData,
      }),
    );
  };

  const handleSubmitEditProduct = (productNewValues: {
    idActivCel: number;
    codProdus: string;
    lot: string;
    dataExpirare: string;
    cantitate: number;
  }) => {
    dispatch(
      postEditDepositStockProduct({
        params: productNewValues,
        filters: tableFilterData,
      }),
    );
  };

  const goToProductHistory = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.depositStocks}/${inventoryRoutes.productHistory}?codProdus=${crudData.codProdus}&lot=${crudData.lot}&dataExpirare=${crudData.dataExpirare}&numeProdusErp=${crudData.numeProdusErp}`;
  };

  return (
    <>
      {isSplitModalOpen && crudData && (
        <DepositStocksTransferModal
          productData={crudData}
          isSplitModalOpen={isSplitModalOpen}
          setIsSplitModalOpen={setIsSplitModalOpen}
          tableFilterData={tableFilterData}
        />
      )}
      {isEditModalOpen && crudData && (
        <EditProductModal
          productData={crudData}
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
          handleSubmitEditProduct={handleSubmitEditProduct}
        />
      )}

      <ActionMenu
        minItemsForMenu={2}
        title={crudData.numeProdusErp}
        ariaLabel={`Actiuni pentru produsul ${crudData.numeProdusErp}`}
        items={[
          {
            id: "transfer",
            label: "Transfera produs",
            icon: "TRANSFER",
            tooltip: "Deschide repartizarea cantitatii produsului pe depozite.",
            onClick: () => setIsSplitModalOpen(true),
          },
          {
            id: "edit",
            label: "Editeaza produs",
            icon: "EDIT",
            tooltip: "Modifica datele produsului din celula curenta.",
            hidden: !isAuthorized(userRoles.DEPOSIT_STOCKS_ACTION),
            onClick: () => setIsEditModalOpen(true),
          },
          {
            id: "history",
            label: "Istoric produs",
            icon: "HISTORY",
            tooltip:
              "Deschide istoricul produsului pentru acest lot si data de expirare.",
            hidden: !isAuthorized(userRoles.DEPOSIT_STOCKS_ACTION),
            navigate: goToProductHistory(),
          },
          {
            id: "delete",
            dividerBefore: true,
            label: "Sterge produs",
            icon: "DELETE",
            color: "error",
            tooltip: "Sterge produsul din celula curenta dupa confirmare.",
            hidden: !isAuthorized(userRoles.DEPOSIT_STOCKS_DELETE),
            withConfirmationModal: {
              modalLeftButtonVariant: "outlined",
              modalTitle: `Doriti sa stergeti din celula produsul: "${crudData.numeProdusErp}"?`,
              modalRightButtonOnClick: handleDeleteProduct,
            },
          },
        ]}
      />
    </>
  );
}

export default DepositStocksActionButtons;
